import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { Component, OnInit, Inject } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MODELS } from '../../admin/shared/models/models';
import { AddService } from '../../admin/add-edit/add.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

interface ExamParams {
  examName: string;
  startDate: string;
  startTime: string;
  endTime: string;
  passingPercentage: number;
  totalMarks: number;
  examCode: string;
}

@Component({
  selector: 'app-exam-qr',
  templateUrl: './exam-qr.component.html',
  styleUrls: ['./exam-qr.component.scss']
})
export class ExamQrComponent implements OnInit {
  examForm: FormGroup;
  qrData: string = '';
  public qrCodeDownloadLink: SafeUrl = '';
  width: number = 256;
  showQR: boolean = false;
  model: string;
  chapterId: string;

  constructor(
    private dialogRef: DialogRef<ExamQrComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.model = data.model;
    this.chapterId = data.chapterId;
  }

  ngOnInit(): void {
    this.qrData = `${environment.siteUrl}chapter-details/${this.chapterId}`;
  }


  closeDialog() {
    this.dialogRef.close();
  }

 
}